import React from 'react'
import { formatUsd, type ReportPackId, type ReportPackOption } from '../../lib/reportPacks'

interface ReportPackPickerProps {
  options: ReportPackOption[]
  value: ReportPackId
  onChange: (id: ReportPackId) => void
}

export default function ReportPackPicker({ options, value, onChange }: ReportPackPickerProps) {
  if (options.length < 2) return null
  return (
    <div role="radiogroup" aria-label="Number of reports" className="grid grid-cols-3 gap-2">
      {options.map((option) => {
        const selected = option.id === value
        return (
          <button
            key={option.id}
            type="button"
            role="radio"
            aria-checked={selected}
            onClick={() => onChange(option.id)}
            className={`rounded-xl border px-2 py-2 text-center transition-colors ${
              selected
                ? 'border-blue-500 bg-blue-50 dark:bg-blue-900/30'
                : 'border-gray-200 dark:border-gray-700 hover:bg-gray-50 dark:hover:bg-gray-700/50'
            }`}
          >
            <span className="block text-sm font-semibold text-gray-900 dark:text-white">
              {option.reports} {option.reports === 1 ? 'report' : 'reports'}
            </span>
            <span className="block text-xs text-gray-500 dark:text-gray-400">{formatUsd(option.priceCents)}</span>
            {option.savingsPercent > 0 && (
              <span className="block text-[11px] font-semibold text-green-600 dark:text-green-400">
                Save {option.savingsPercent}%
              </span>
            )}
          </button>
        )
      })}
    </div>
  )
}
